export default {
    getCalendarViewService: 'getCalendarViewService',
    addEventsToCacheFromNetwork: 'addEventsToCacheFromNetwork',
    getEventsFromSessionStorage: 'getEventsFromSessionStorage',
    addEventsToCacheFromSessionStorage: 'addEventsToCacheFromSessionStorage',
};
